import { useMemo } from "react";
import useSWR from "swr";

import { postAccountTrades } from "lib/apis/accounts";

export default function useIsFirstOrder(chainId: number, p: { account?: string }) {
  const { account } = p;

  const key = account ? ["useIsFirstOrder", chainId, account] : null;

  const { data: isFirstOrder } = useSWR<boolean>(key, {
    fetcher: async () => {
      const result = await postAccountTrades(account!.toLowerCase(), {
        chainId,
        account: account?.toLowerCase(),
        page: 0,
        pageSize: 1,
        forAllAccounts: false,
      });
      const tradesCount = result?.items?.length ?? 0;
      return tradesCount === 0;
    },
  });

  return useMemo(() => {
    return { isFirstOrder: isFirstOrder ?? true };
  }, [isFirstOrder]);
}
